const scope = 'app/ErrorHandler/';
export const SET_ERROR = `${scope}SET_ERROR`;
export const SET_INFO = `${scope}SET_INFO`;
